import { useLocalization } from '@/Hooks';

export const useShouldBeDecimal = (props: 'decimal' | 'currency' | 'weight' | 'size' | 'price' = 'decimal') => {
  const { validation } = useLocalization();

  let regex: RegExp;
  let message: string;

  switch (props) {
    case 'size': {
      regex = /^-?\d+([.,]\d)?$/;
      message = validation.ValueMustBeSizeNumber;
      break;
    }

    case 'currency': {
      regex = /^(\d{1,3}(,\d{3})*|\d+)(\.\d{1,2})?$/;
      message = validation.ValueMustBeCurrencyNumber;
      break;
    }

    case 'weight': {
      regex = /^-?\d+([.,]\d{1,3})?$/;
      message = validation.ValueMustBeWeightNumber;
      break;
    }

    case 'price': {
      regex = /^-?\d+([.,]\d{1,4})?$/;
      message = validation.ValueMustBePriceNumber;
      break;
    }

    default: {
      regex = /^-?\d+([.,]\d{1,5})?$/;
      message = validation.ValueMustBeNumber;
      break;
    }
  }

  return {
    pattern: {
      value: regex,
      message: message,
    },
  };
};
